export default {
  accountTables: {
    search: {
      scope: "Scope",
      lowerBound: "Lower Bound",
      load: "LOAD"
    },
    tables: {
      dropdown: {
        placeholder: "Select a table"
      }
    }
  }
}
